module.exports = __webpack_public_path__ + "videos/optimised/1fe8d202c8d3a3e7ef27f5d01a828c0b.mp4";